export default {
  'menu.welcome': 'Welcome',
  'menu.workbench': 'Workbench',
  'menu.workbench.today-overview': 'Today Overview',
  'menu.home': 'Home',
  'menu.system': 'System',
  'menu.system.menu': 'Menu',
  'menu.system.role': 'Role',
  'menu.system.user': 'User',
  'menu.system.admin-account': 'Admin Accounts',
  'menu.system.coach': 'Coaches',
  'menu.system.logger': 'Logger',
  'menu.account.settings': 'Account Settings',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.member': 'Members',
  'menu.member_injury': 'Member Injuries',
  'menu.member_ops': 'Member Operations',
  'menu.member_ops.member-list': 'Member List',
  'menu.member_ops.member-injury': 'Member Injuries',
  'menu.member_ops.member-movement-library': 'Member Movement Library',
  'menu.member_ops.member-feature': 'Member Features',
  'menu.card_collection': 'Cards & Payments',
  'menu.card_collection.card-templates': 'Card Type Center',
  'menu.card_collection.card-instance-center': 'Card Instance Center',
  'menu.card_collection.pause-operation-center': 'Pause / Resume Operations',
  'menu.card_collection.transaction-order-center': 'Transaction Orders',
  'menu.card_collection.payment-reconciliation': 'Payment Reconciliation',
  'menu.course_ops': 'Classes & Fulfillment',
  'menu.course_ops.course-schedule': 'Course Schedule',
  'menu.training_content': 'Training Content',
  'menu.training_content.wod-template': 'WOD Templates',
  'menu.training_content.movement-library': 'Movement Library',
  'menu.training_content.accessories': 'Accessories',
  'menu.training_content.fitness-mappings': 'Fitness Model Mappings',
  'menu.training_content.media-assets': 'Media Assets',
  'menu.mini_ai': 'Mini Program & AI',
  'menu.mini_ai.ai-video-review': 'AI Video Review',
  'menu.mini_ai.wx-share-config': 'Mini Share Config',
  'menu.mini_ai.wx-mini-qrcode': 'Mini QR Codes',
  'menu.movements': 'Movements',
  'menu.movements.index': 'Movements',
  'menu.movements.accessories': 'Accessories',
  'menu.movements.fitness-mappings': 'Fitness Model Mappings',
  'menu.movements.member-videos': 'Member Movement Review',
  'menu.medias': 'Media',
  'menu.wod': 'WOD',
  'menu.course_schedule': 'Course Schedule',
  'menu.ai_video': 'AI Video Review',
  'menu.wx_share_config': 'Mini Share Config',
  'menu.wx_mini_qrcode': 'Mini QR Codes',
};
